export default {
  simulationData: 'Simulationsdaten',
  showPreview: 'Vorschau des Simulator Rezepts',
  selectUnitHeader: 'Einheitensystem',
  timeoutSeconds: 'Maximale Simulationszeit',
};
